<div class="modal-header d-flex align-items-center justify-content-between">
  <h3 class="modal-title">Dropdown Option</h3>
  <div class="d-flex">
    <button
      class="btn btn-sm btn-default"
      (click)="addInputOption()"
      aria-hidden="true"
    >
      Add
    </button>
    <button
      class="fa fa-times"
      [mat-dialog-close]=""
      style="float: right; cursor: pointer; background: none; border: none"
      aria-hidden="true"
    ></button>
  </div>
</div>
<div class="modal-body">
  <div
    class="overflow-x mt-3"
    style="width: 100%"
    *ngFor="let item of columnObj.option; let i = index"
  >
    <input
      type="text"
      [value]="item"
      class="form-control form-control-sm inputtext"
      (blur)="inputOptionValue($event, i)"
    />
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default" [mat-dialog-close]="" (click)="saveOptionValue()">Save</button>
</div>
